import { ClientInferResponseBody } from "@ts-rest/core";

import { quoteRequestLinesContract } from "../api/quoteRequestLinesContract";
import { MaterialGradeType } from "../types";

export type QuoteRequestLineDto = ClientInferResponseBody<
  typeof quoteRequestLinesContract.findOne,
  200
>;

export const getMaterialGrade = ({
  quoteRequestLineMaterialGrade,
  partMaterialGrade,
}: {
  quoteRequestLineMaterialGrade: MaterialGradeType | undefined | null;
  partMaterialGrade: MaterialGradeType | undefined | null;
}): MaterialGradeType | null => {
  return (quoteRequestLineMaterialGrade || partMaterialGrade) ?? null;
};
